import { createStore, applyMiddleware, combineReducers } from 'redux'
import logger from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import { productBuilderReducer, productBuilderSaga } from '../features/product-builder'
import { envProduction } from '../core/env'

const sagaMiddleware = createSagaMiddleware()


export const store = envProduction
    ? createStore(
        combineReducers({ productBuilderState: productBuilderReducer }),
        <any>applyMiddleware(sagaMiddleware)
    )
    : createStore(
        combineReducers({ productBuilderState: productBuilderReducer }),
        <any>applyMiddleware(sagaMiddleware, logger)
    )

sagaMiddleware.run(productBuilderSaga)